import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.scss']
})
export class TitleBarComponent implements OnInit {
  envLabel: string = '';
  constructor() { }
  ngOnInit() {
    this.envLabel = this.getEnvironmentLabel();
  }
  
  private getEnvironmentLabel(): string {
    const hostname = globalThis.location.hostname;
    const protocol = globalThis.location.protocol;
    const origin = `${protocol}//${hostname}/`;

    if (origin.includes('localhost') || origin.includes('-d')) {
      console.log('running DEV')
      return ' - DEV';
    } else if (origin.includes('-q')) {
      console.log('running QA')
      return ' - QA';
    } else if (origin.includes('sqip.dp.schaeffler')) {
      return '';
    }
    return '';
  }
}
